/* @ngInject */
const go = (
  $state,
  dispatchLocal,
  routes
) => {
  const self = {}

  self.consult = (_id) => {
    dispatchLocal.saveCurrentId(_id)
    $state.go(routes.consult.dispatch.details.path)
  }

  self.edit = (_id) => {
    dispatchLocal.saveCurrentId(_id)
    $state.go(routes.consult.dispatch.edit.path)
  }

  self.new = () => {
    $state.go(routes.consult.dispatch.new.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/go.service.js